var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"jbContainer",staticClass:"jb-container",attrs:{"id":"jbContainer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }